// Configurazione centralizzata di Fruttipedia (indirizzi, categorie, social).
// Aggiornare qui qualunque collegamento esterno: viene usato da header, footer e pagine.

export const LINKS = {
  // Home generale Lumacofono / "Le teorie dal mondo" (in preparazione, link intenzionale)
  lumacofono: "https://www.lumacofono.com",
  ciurma: "https://ciurma.lumacofono.com",
  sbustaop: "https://sbustaop.lumacofono.com",
};

// Collegamenti social ufficiali (invariati).
export const SOCIALS = [
  { key: "youtube", label: "YouTube", url: "https://youtube.com/@lumacofonopodcast" },
  { key: "instagram", label: "Instagram", url: "https://www.instagram.com/lumacofono_podcast" },
  { key: "spotify", label: "Spotify", url: "https://open.spotify.com/show/2QRg3xuiNzzMweAuAr46zT" },
  { key: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@lumacofono.podcast" },
  { key: "twitch", label: "Twitch", url: "https://twitch.tv/lumacofono" },
];

// Le quattro esperienze Lumacofono (Fruttipedia è interna a questo progetto).
export const EXPERIENCES = [
  { label: "Le teorie dal mondo", url: LINKS.lumacofono, external: true },
  { label: "Crea la tua ciurma", url: LINKS.ciurma, external: true },
  { label: "SbustaOP", url: LINKS.sbustaop, external: true },
  { label: "Fruttipedia", to: "/", external: false, current: true },
];

// Categorie visuali della home. "value" corrisponde alla classificazione reale nel database,
// "label" è solo l'etichetta mostrata. NON riclassifica i dati.
export const CATEGORIES = [
  {
    label: "Paramecia",
    value: "Paramisha",
    color: "#9055E9",
    desc: "I frutti più vari: donano al corpo o all'ambiente un potere speciale, senza trasformare in un elemento o in un animale.",
  },
  {
    label: "Zoan",
    value: "Zoo Zoo",
    color: "#16B8D6",
    desc: "Permettono di trasformarsi in un animale e nelle sue forme ibride. Includono i tipi ancestrali e mitologici.",
  },
  {
    label: "Rogia",
    value: "Rogia",
    color: "#C64BB4",
    desc: "I frutti elementali: trasformano il corpo in un elemento naturale, rendendo spesso quasi inafferrabili.",
  },
];
